import { Map, List } from 'immutable'
import {
  SET_COMMENTS,
  SET_COMMENTS_OFFSET_LIMIT,
  SET_COMMENTS_DATA_ITEM_STATUS,
  SET_COMMENTS_DATA_ITEM_PUBLIHSING,
  DELETE_COMMENTS_DATA_ITEM_PUBLIHSING,
} from './actions'

export const initialState = Map()

export default (state = initialState, action) => {
  const { payload, type } = action
  switch (type) {
    case SET_COMMENTS: {
      const {
        storeKey, data, total, processing,
      } = payload
      return state.update(
        storeKey,
        Map(),
        (branch) => branch.merge(Map({ data, total, processing })),
      )
    }
    case SET_COMMENTS_OFFSET_LIMIT: {
      const {
        storeKey, offset, limit, processing,
      } = payload
      return state.update(
        storeKey,
        Map(),
        (branch) => branch.merge(Map({ offset, limit, processing })),
      )
    }
    case SET_COMMENTS_DATA_ITEM_STATUS: {
      const { storeKey, item, status } = payload
      return state.updateIn([storeKey, 'data'], List(), (data) => {
        const index = data.findIndex((dataItem) => dataItem.get('id') === item.get('id'))
        if (index > -1) {
          return data.setIn([index, 'status'], status)
        }
        return data
      })
    }
    case SET_COMMENTS_DATA_ITEM_PUBLIHSING: {
      const { storeKey, item, publishing } = payload
      return state.updateIn([storeKey, 'data'], List(), (data) => {
        const index = data.findIndex((dataItem) => dataItem.get('id') === item.get('id'))
        return index > -1 ? data.setIn([index, 'publishing'], publishing) : data
      })
    }
    case DELETE_COMMENTS_DATA_ITEM_PUBLIHSING: {
      const { storeKey, item } = payload
      return state.updateIn([storeKey, 'data'], List(), (data) => {
        const index = data.findIndex((dataItem) => dataItem.get('id') === item.get('id'))
        return index > -1 ? data.deleteIn([index, 'publishing']) : data
      })
    }
    default:
      return state
  }
}
